export const environment = {
    name: 'production',
    url: ''
};
